import client from './client';
import qs from 'qs';

/**
 * 데이터센터 - 쿠키모수현황 그래프
 */
export const cookieParamGraph = (param) =>
  client.get(`/api/report/datacenter/status/graph`, { params: param });

/**
 * 데이터센터 - 오디언스매칭 유저수 그래프
 */
export const audienceUserGraph = (param) =>
  client.get(`/api/report/datacenter/auusergraph`, { params: param });

/**
 * 데이터센터 - ADID 수집현황 그래프 (페이지)
 */
export const appadiddayGraph = (param) =>
  client.get(`/api/report/datacenter/appadidday/graph`, { params: param });

/**
 * 데이터센터 - ADID 수집현황 그래프 (메인)
 */
export const adidStatusGraph = (param) =>
  client.get(`/api/report/datacenter/adidgraph`, { params: param });

/**
 * 데이터센터 - 오디언스매칭 신규유저수 그래프
 */
export const audienceNewGraph = (param) =>
  client.get(`/api/report/datacenter/aunewgraph`, { params: param });

/**
 * 데이터센터 - 광고쿠키 통계
 */
export const CookieStatisticsData = (param) =>
  client.get(`/api/report/datacenter/cookie`, param);

/**
 * 데이터센터 - 앱모수타겟팅 일자별통계
 */
export const appTargetingDailyStatistics = (param) =>
  client.get(`/api/report/datacenter/appTargetingDaily`, param);

/**
 * 데이터센터 - 앱모수타겟팅 일자별통계 그래프
 */
export const appTargetingDailyGraph = (param) =>
  client.get(`/api/report/datacenter/daygraph`, {
    params: param,
  });

/**
 * 데이터센터 - 앱모수타겟팅 매체통계
 */
export const appTargetingMediaStatisticsData = (param) =>
  client.get(`/api/report/datacenter/appmedia`, param);

/**
 * 데이터센터 - 앱모수타겟팅 광고주통계
 */
export const appTargetingAdverStatisticsData = (param) =>
  client.get(`/api/report/datacenter/appadver`, param);

/**
 * 데이터센터 - ADID 수집 현황
 */
export const adidStatusStatisticsData = (param) =>
  client.get(`/api/report/datacenter/appadidday`, param);

/**
 * 데이터센터 - ADID 수집 현황
 */
export const appStatusStatisticsData = (param) =>
  client.get(`/api/report/datacenter/appnewadid`, param);

/**
 * 데이터센터 - 앱 패키지 그래프
 */
export const appStatusGraphData = (param) =>
  client.get(`/api/report/datacenter/apppkgraph`, { params: param });

/**
 * 데이터센터 - 오디언스매칭 통계
 */
export const audienceStatisticsData = (param) =>
  client.get(`/api/report/datacenter/audience`, param);

/**
 * 데이터센터 - 오디언스매칭 통계
 */
export const audienceStatisticsSubData = (param) =>
  client.get(`/api/report/datacenter/audience/sub`, param);

/**
 * 데이터센터 - 오디언스매칭 통계 그래프
 */
export const audienceGraphData = (param) =>
  client.get(`/api/report/datacenter/audience/graph`, { params: param });

/**
 * 데이터센터 - app필터링 통계
 * @param param
 * @returns {Promise<AxiosResponse<T>>}
 */
export const appFiltering = (param) =>
  client.get(`/api/report/datacenter/filtering`, param);

/**
 * 필터링 app 추가
 * @param params
 * @returns {Promise<AxiosResponse<T>>}
 */
export const appFilteringAdd = (params) =>
  client.post(`/api/report/datacenter/filtering/add`, qs.stringify(params));

/**
 * 필터링 app 삭제
 * @param appNos
 * @returns {Promise<AxiosResponse<T>>}
 */
export const appFilteringDel = (appNos) =>
  client.delete(`/api/report/datacenter/filtering/delete`, {
    data: appNos,
  });

/**
 * 데이터센터 - 오디언스매칭 컨버전 상세
 */
export const audienceConversion = (param) =>
  client.get(`/api/report/datacenter/audience/conversion`, param);

/**
 * 데이터센터 - 오디언스매칭 광고주 리스트
 */
export const audienceAdver = (param) =>
  client.get(`/api/report/datacenter/audience/adver`, param);
